import type { ReactNode } from "react";
import { Button } from "@heroui/react";
import { History } from "lucide-react";
import { cn } from "@/lib/utils";

/** Buy / Sell look the same live and in a replay (Binance's two big buttons). */
export const BUY_CLASS = "w-full font-semibold bg-profit text-on-profit";
export const SELL_CLASS = "w-full font-semibold bg-loss text-on-loss";

/** The bar under the chart: tools on the left, the two big actions on the right. */
export function ActionBarShell({ left, right, className }: { left?: ReactNode; right?: ReactNode; className?: string }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-x-3 gap-y-2 border-t border-separator px-3 py-2 text-xs", className)}>
      {left}
      {right && <div className="ms-auto grid w-full grid-cols-2 gap-2 sm:w-72">{right}</div>}
    </div>
  );
}

/** Live: the way into replay, and Buy / Sell (they open the trade ticket). */
export function LiveActionBar({
  onReplay, onBuy, onSell,
}: { onReplay?: () => void; onBuy?: () => void; onSell?: () => void }) {
  return (
    <ActionBarShell
      left={onReplay && (
        <Button size="sm" variant="ghost" onPress={onReplay} className="gap-1.5 px-2 text-muted hover:text-foreground">
          <History className="size-4" />
          Replay
          <span className="hidden text-muted @xl:inline">· practise on past candles</span>
        </Button>
      )}
      right={onBuy && onSell && (
        <>
          <Button size="md" className={BUY_CLASS} onPress={onBuy}>Buy</Button>
          <Button size="md" className={SELL_CLASS} onPress={onSell}>Sell</Button>
        </>
      )}
    />
  );
}
